import { PricingRowDto } from "../pricing/PricingRow"
import { Row } from "../rows/Row"
import { GroupDto } from "../pricing/Group"
import { PricingTotalDto } from "../pricing/PricingTotals"
import { QUOTES } from "./Constants"

type QuoteDtoAttributes = {
    items: PricingRowDto[] | Row[]
    identifier: string
    groups: GroupDto[]
    totals: PricingTotalDto[]
    pricingTableId: string
}

export type QuoteDto = {
    id: string,
    type: typeof QUOTES,
    attributes: QuoteDtoAttributes
}

export default class Quote {
    private dto: QuoteDto
    constructor(dto: QuoteDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "quotes"
    }

    getId(): string {
        return this.dto.id
    }

    getAttributes(): QuoteDtoAttributes {
        return this.dto.attributes
    }

    getIdentifier(): string {
        return this.dto.attributes.identifier
    }
}


// WEBPACK FOOTER //
// ./src/state/quote/Quote.ts